import React from 'react';
import PropTypes from 'prop-types';

const CarouselItem = props =>
  React.cloneElement(props.item, {
    inView: props.inView,
    onClick: props.onClick,
    'data-test': 'CarouselItem',
  });

const { node, bool, func } = PropTypes;
CarouselItem.propTypes = {
  item: node.isRequired,
  inView: bool,
  onClick: func,
};

CarouselItem.defaultProps = {
  inView: false,
  onClick: () => {},
};

export default CarouselItem;
